import React from 'react';
import { MapPin, Phone, Clock } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';

export const Locations = ({ onOpenLongpont, onOpenMennecy }) => {
  return (
    <section id="etablissements" className="py-24 px-4 sm:px-6 lg:px-8 bg-white" data-testid="locations-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-[#0205B3] text-white px-4 py-2 rounded-full text-sm font-bold mb-4">
            <MapPin className="h-5 w-5" />
            <span>2 ÉTABLISSEMENTS EN ESSONNE</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Nos 2 Pressings AQUABLUENET
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Deux pressings professionnels pour vous servir dans l'Essonne (91) : <strong>Longpont-sur-Orge</strong> et <strong>Mennecy</strong>. Même qualité, même technologie écologique Lagoon, carte <strong>CleanWay</strong> (5àSec business) acceptée.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 mb-12">
          {/* LONGPONT Location */}
          <Card
            className="overflow-hidden shadow-xl border-2 border-[#0205B3] cursor-pointer hover:shadow-2xl transition-all duration-300 hover:scale-105"
            onClick={onOpenLongpont}
            data-testid="longpont-card"
          >
            <CardContent className="p-0">
              <div className="bg-[#0205B3] text-white p-6 text-center">
                <h3 className="text-2xl font-bold">Longpont-sur-Orge</h3>
                <p className="text-blue-100 font-semibold mt-1">91310</p>
              </div>
              <div className="p-6 space-y-4">
                <div className="flex items-start gap-3">
                  <MapPin className="h-5 w-5 text-[#0205B3] flex-shrink-0 mt-1" />
                  <div>
                    <p className="font-semibold text-gray-900">Adresse</p>
                    <p className="text-gray-600">
                      Intermarché<br />
                      Zac des Échassons<br />
                      91310 Longpont-sur-Orge
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <Phone className="h-5 w-5 text-[#0205B3] flex-shrink-0 mt-1" />
                  <div>
                    <p className="font-semibold text-gray-900">Téléphone</p>
                    <a href="tel:0169807375" className="text-[#0205B3] hover:underline font-medium">
                      01 69 80 73 75
                    </a>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <Clock className="h-5 w-5 text-[#0205B3] flex-shrink-0 mt-1" />
                  <div>
                    <p className="font-semibold text-gray-900">Horaires</p>
                    <p className="text-gray-600">
                      Mardi - Samedi<br />
                      10h00 - 19h00
                    </p>
                  </div>
                </div>
                <Button
                  className="w-full bg-[#0205B3] hover:bg-[#0205B3]/90 text-white"
                  onClick={(e) => { e.stopPropagation(); window.open('https://www.google.com/maps?q=Intermarché+Longpont-sur-Orge+91310', '_blank'); }}
                  data-testid="longpont-map-btn"
                >
                  <MapPin className="mr-2 h-4 w-4" />
                  Itinéraire Longpont
                </Button>
              </div>
            </CardContent>
          </Card>

          {/* MENNECY Location */}
          <Card
            className="overflow-hidden shadow-xl border-2 border-green-600 cursor-pointer hover:shadow-2xl transition-all duration-300 hover:scale-105"
            onClick={onOpenMennecy}
            data-testid="mennecy-card"
          >
            <CardContent className="p-0">
              <div className="bg-green-600 text-white p-6 text-center">
                <h3 className="text-2xl font-bold">Mennecy</h3>
                <p className="text-green-100 font-semibold mt-1">91540</p>
              </div>
              <div className="p-6 space-y-4">
                <div className="flex items-start gap-3">
                  <MapPin className="h-5 w-5 text-green-600 flex-shrink-0 mt-1" />
                  <div>
                    <p className="font-semibold text-gray-900">Adresse</p>
                    <p className="text-gray-600">
                      Intermarché<br />
                      Rue Jean Cocteau<br />
                      91540 Mennecy
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <Phone className="h-5 w-5 text-green-600 flex-shrink-0 mt-1" />
                  <div>
                    <p className="font-semibold text-gray-900">Téléphone</p>
                    <a href="tel:0984509942" className="text-green-600 hover:underline font-medium">
                      09 84 50 99 42
                    </a>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <Clock className="h-5 w-5 text-green-600 flex-shrink-0 mt-1" />
                  <div>
                    <p className="font-semibold text-gray-900">Horaires</p>
                    <p className="text-gray-600">
                      Mardi - Samedi<br />
                      9h30 - 19h00
                    </p>
                  </div>
                </div>
                <Button
                  className="w-full bg-green-600 hover:bg-green-700 text-white"
                  onClick={(e) => { e.stopPropagation(); window.open('https://www.google.com/maps?q=Intermarché+Rue+Jean+Cocteau+Mennecy+91540', '_blank'); }}
                  data-testid="mennecy-map-btn"
                >
                  <MapPin className="mr-2 h-4 w-4" />
                  Itinéraire Mennecy
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Common features */}
        <div className="bg-gradient-to-br from-blue-50 to-green-50 rounded-2xl p-8 shadow-lg">
          <h3 className="text-2xl font-bold text-center text-gray-900 mb-6">
            Les 2 pressings proposent :
          </h3>
          <div className="grid md:grid-cols-3 gap-6 text-center">
            <div>
              <div className="bg-green-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-3">
                <svg className="h-8 w-8 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">Carte CleanWay</h4>
              <p className="text-sm text-gray-600">Partenaire <strong>5àSec business</strong> — acceptée dans les 2 pressings</p>
            </div>
            <div>
              <div className="bg-blue-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-3">
                <svg className="h-8 w-8 text-[#0205B3]" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">Technologie Lagoon</h4>
              <p className="text-sm text-gray-600">Nettoyage 0% Perchlo, 100% naturel</p>
            </div>
            <div>
              <div className="bg-blue-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-3">
                <svg className="h-8 w-8 text-[#0205B3]" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">Tous les services</h4>
              <p className="text-sm text-gray-600">Même qualité professionnelle</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
